import { render } from "./index.vue?vue&type=template&id=60b9f7a2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=60b9f7a2&lang=scss"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__